import API from '@services/API';

const EventStreamLogService = {


	listar: async(filter) => await API.list(`evtlogs?descricao=${filter}`),
	resolverErro: async (topico,particao,offset) => await API.put(`evtlogs/${topico}/${particao}/${offset}/resolver`, {}),
	resolverErroEmLote: async (obj) => await API.put(`evtlogs/resolverEmLote`, obj),


}

export default EventStreamLogService;
